import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import DemoDashboard from './pages/DemoDashboard'
import EpochRewards from './pages/EpochRewards'
import AdminDashboard from './pages/AdminDashboard'
import StakingDashboard from './pages/StakingDashboard'
import StakingDocs from './pages/StakingDocs'

function App() {
  return (
    <div className="app">
      <Routes>
        {/* SKR Liquid Staking — Dashboard + Documentation */}
        <Route path="/staking" element={<StakingDashboard />} />
        <Route path="/staking/docs" element={<StakingDocs />} />

        {/* Public epoch rewards page */}
        <Route path="/rewards" element={<EpochRewards />} />
        <Route path="/epoch" element={<EpochRewards />} />
        
        {/* Admin dashboard with wallet signature auth */}
        <Route path="/admin" element={<AdminDashboard />} />
        
        {/* Demo dashboard route */}
        <Route path="/demo" element={<DemoDashboard />} />
        
        {/* Redirect root to staking dashboard */}
        <Route path="/" element={<Navigate to="/staking" replace />} />
        
        {/* Redirect old dashboard route to admin */}
        <Route path="/dashboard" element={<Navigate to="/admin" replace />} />
        
        {/* 404 fallback */}
        <Route path="*" element={<Navigate to="/staking" replace />} />
      </Routes>
    </div>
  )
}

export default App
